module.exports = __webpack_public_path__ + "img/4-5.da85b716.svg";